import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PublishingLimitComponent } from "./publishing-limit.component";
import { TranslateModule } from "@ngx-translate/core";
import { NzInputNumberModule } from "ng-zorro-antd/input-number";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzGridModule } from "ng-zorro-antd/grid";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [PublishingLimitComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzInputNumberModule,
    NzSpinModule,
    NzButtonModule,
    NzIconModule,
    NzGridModule,
    FormsModule,
  ],
  exports: [PublishingLimitComponent],
})
export class PublishingLimitModule {}
